import UltMeta, { Meta } from "./UltMeta/index";

// 打包报表类型
class ReportZipType extends UltMeta {
    BOUND_DETAILS = new Meta(1, "出入库明细表");
    CORE_LIBRARY = new Meta(2, "核库报表");
    WAREHOUSE_INSPECTION = new Meta(3, "入库检测表");
    SAMPLING_INSPECTION = new Meta(4, "抽样检测表");
    INVENTORY_SUMMARY = new Meta(5, "盘点汇总表");
}

export const REPORT_ZIP_TYPE = new ReportZipType();
